
import Vue from "vue";
// import ChangeLanguage from "@/components/shared/ChangeLanguage.vue";

export default Vue.extend({
  name: "AuthBoardingHeader",
  computed: {
    // Fully dynamic tenant logo (from DB branding). No static fallback:
    // pre-login it comes from the branding store (resolved via the ?company slug),
    // post-login from the logged-in company's branding.
    brand_logo(): string {
      return (
        this.$store.state.branding?.logo_uri ||
        this.$store.getters["auth/GET_COMPANY_DETAILS"]?.storage_path?.branding
          ?.logo_uri ||
        ""
      );
    }
  }
});
